/** Prefix of every account's cached risk-report doc info. Invalidating on it
 *  alone refreshes all of them. */
export const RISK_REPORT_DOC_INFO_KEY = 'risk-report-doc-info';

export const riskReportDocInfoQueryKey = (accountId: string) => [
  RISK_REPORT_DOC_INFO_KEY,
  { accountId },
];
